import template from './lenderSplitSmall.html';
import controller from './lenderSplitSmallCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    myParam: '<',
  },
};
